function Authentication_login(element) {
    this.$element = $(element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]',
	    buttonSubmit: '.js-button-submit',
	    webkitAutofill: ':-webkit-autofill'
    };

    this.triggers = {
	    afterLoaded: 'i4:afterLoaded',
	    updateView: 'i4:updateView'
    };

    this.data = {
	    loginTimeout: 'login-timeout'
    };

    this.init = function() {

	    this.$formParent = this.$element.parents(this.selectors.formParent);
	    this.$buttonSubmit = this.$element.find(this.selectors.buttonSubmit);

	    this.dataLoginTimeout = this.$element.data(this.data.loginTimeout);

	    if (this.dataLoginTimeout > 3) {
		    this.hideButtonSubmit();
	    }

		setTimeout(this.validateAutofill.bind(this), 100); // needed for the chrome autofill
    };

    this.validateAutofill = function() {

	    this.$fieldsAutofill = this.$element.find(this.selectors.webkitAutofill);

		if (this.$fieldsAutofill.length) {

		    this.$fieldsAutofill.each((function(i, item) {

			    $(item).
			    	addClass('valid').
			    	removeClass('invalid');

		    }).bind(this));

		    this.$formParent.trigger(this.triggers.updateView);
	    }
    };

    this.hideButtonSubmit = function() {
	    this.$buttonSubmit.hide();

		setTimeout((function() {
			this.$buttonSubmit.show();
		}).bind(this), this.dataLoginTimeout * 1000);
    };
}
